<template>
  <div class="opple-date-picker">
    <div v-if="!hidenMonth" class="opple-date-picker_header">
      {{ getMonthName(month) }}
    </div>
    <el-calendar :value="localFirstDay">
      <template slot="dateCell" slot-scope="{ date, data }">
        <div :class="{ 'hidden-date': new Date(data.day).getMonth() + 1 !== month }" class="date-block" @click="e => handlerDateTrigger(e, data)">
          <el-button
            type="text"
            :disabled="isDateDisabled(date)"
            class="date-circle"
            :class="[selectedDay.includes(data.day) && !isDateDisabled(data.day) ? 'selected' : '', isManuallyAdded(data.day) && !isDateDisabled(data.day) ? 'manual-modified' : '']"
          >
            {{ data.day.split('-').slice(2).join('') }}
          </el-button>
          <div
            v-if="holidayDateList.includes(data.day)"
            :title="getHolidayLabel(data.day)"
            class="date-holiday"
            :class="{
              week: ((holidayList.find(item => item.date === data.day) || {}).dateType === 1) && !isDateDisabled(data.day),
              holiday: ((holidayList.find(item => item.date === data.day) || {}).dateType !== 1) && !isDateDisabled(data.day)
            }"
            :style="isDateDisabled(data.day) || !selectedDay.includes(data.day) ? { color: '#ccc' } : {}"
          >
            {{ getHolidayLabel(data.day) }}
          </div>
          <div v-if="isManuallyAdded(data.day) && !isDateDisabled(data.day)" class="date-holiday date-custom">
            {{ $t('iftttset.customize') }}
          </div>
        </div>
      </template>
    </el-calendar>
  </div>
</template>
<script>
export default {
  components: {},
  props: {
    hidenMonth: {
      type: Boolean,
      default: false,
    },
    month: {
      type: Number,
      default: 1,
    },
    firstDay: {
      type: Date,
      default: new Date(),
    },
    holidayList: {
      type: Array,
      default: () => [],
    },
    holidayDateList: {
      type: Array,
      default: () => [],
    },
    defaultSelect: {
      type: Array,
      default: () => [],
    },
    countryValue: {
      type: String,
      default: 'CN',
    },
  },

  data() {
    return {
      selectedDay: [],
      holidays: {
        春节: this.$t('projectmsg.springFestival'),
        清明节: this.$t('projectmsg.tombSweepingDay'),
        端午节: this.$t('projectmsg.dragonBoatFestival'),
        中秋节: this.$t('projectmsg.midAutumnFestival'),
        元旦节: this.$t('projectmsg.newYearsDay'),
        周末: this.$t('projectmsg.weekEnds'),
        '国庆节、中秋节': this.$t('projectmsg.nationalDay'),
        国庆节: this.$t('projectmsg.nationalDay'),
        劳动节: this.$t('projectmsg.laborDay'),
      },
      localFirstDay: new Date(this.firstDay),
    }
  },

  computed: {
    formattedHolidayDateList() {
      return this.holidayDateList || []
    },
  },

  watch: {
    defaultSelect(val) {
      this.selectedDay = val.slice()
    },
    // holidayDateList(val) {
    //   this.formattedHolidayDateList = val.slice()
    // }, 
    firstDay(newVal) {
      // 用新的 firstDay（新年份日期）重新赋值 localFirstDay
      this.localFirstDay = new Date(newVal);
    },
    
  },
  mounted() {
    this.selectedDay = this.defaultSelect.slice() || []
  },

  created() {},

  methods: {
    getHolidayLabel(day) {
      const item = this.holidayList.find(i => i.date === day)
      if (!item) return ''

      const rawLabel = this.$t(this.holidays[item.label]) || item.label
      return rawLabel.split('、')[0]
    },
    //月份翻译
    getMonthName(month) {
      const monthNames = [this.$t('projectmsg.january'), this.$t('projectmsg.february'), this.$t('projectmsg.march'), this.$t('projectmsg.april'), this.$t('projectmsg.may'), this.$t('projectmsg.june'), this.$t('projectmsg.july'), this.$t('projectmsg.august'), this.$t('projectmsg.september'), this.$t('projectmsg.october'), this.$t('projectmsg.november'), this.$t('projectmsg.december')]
      return monthNames[month - 1]
    },
    isManuallyAdded(day) {
      //6月份
      const month = new Date(day).getMonth() + 1
      // if (month !== 6) return false
      // 是用户现在选中的
      const isSelected = this.selectedDay.includes(day)
      // 不是接口返回的默认节假日
      if (!this.holidayDateList.length) return

      const isNotDefaultHoliday = !this.holidayDateList.includes(day)

      return isSelected && isNotDefaultHoliday
    },

    isDateDisabled(date) {
      const today = new Date()
      today.setHours(0, 0, 0, 0) // 忽略时间部分，只比较日期部分
      const targetDate = new Date(date)
      targetDate.setHours(0, 0, 0, 0) // 忽略时间部分，只比较日期部分
      return targetDate < today
    },
  
    setSelectedDay(data) {
      this.selectedDay = data;
    },

    handlerDateTrigger(e, data) {
      e.stopPropagation()
      e.preventDefault()
      if (this.isDateDisabled(data.day)) return
      const day = data.day
      const targetMonth = new Date(data.day).getMonth() + 1

      // 非当前月的渲染了也不能点击
      if (targetMonth !== this.month) return

      const existIndex = this.selectedDay.findIndex(item => item === day)

      if (existIndex != -1) {
        this.selectedDay.splice(existIndex, 1)
      } else {
        this.selectedDay.push(day)
      }

      this.$emit('changeSelect', this.selectedDay)
    },
  },
}
</script>

<style lang="scss" scoped>
.opple-date-picker {
  background-color: #fff;

  &_header {
    padding: 5px 14px;
    font-size: 14px;
    color: #222;
    font-weight: 600;
  }
  .date-block {
    box-sizing: border-box;
    position: relative;
    text-align: center;
    width: 100%;
    height: 100%;
    padding: 4px;
    overflow: hidden;
    .date-custom {
      font-size: 10px;
      color: #013399;
    }
  }
  .date-circle {
    // position: absolute;
    // right: 10px;
    // top: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 22px;
    height: 22px;
    margin: 0 auto;
    border-radius: 50%;
    text-align: center;
    line-height: 0;
    user-select: none;
    font-size: 12px;

    &.selected {
      background: #469ef5;
      color: #fff;
    }
  }
  .date-circle.manual-modified {
    background: #013399;
    color: #fff;
  }

  .date-holiday {
    // position: absolute;
    font-size: 12px;
    border-radius: 18px;
    text-align: center;
    line-height: 22px;
    user-select: none;
    // background-color: red;
    // color: #fff;

    &.week {
      color: #c9c9c9;
    }

    &.holiday {
      color: #3b89d6;
      font-weight: 700;
    }
  }

  ::v-deep .el-calendar {
    width: 100%;

    .el-calendar__button-group {
      display: none;
    }
    .el-calendar__header {
      display: none;
    }

    .el-calendar__body {
      padding: 10px;
    }
    .el-calendar-day {
      padding: 0;
      height: 46px;
    }

    .current {
      background-color: transparent;
    }
    .next {
      opacity: 0;
      // // display: none;
      // .el-calendar-day {
      //   opacity: 0;
      // }
    }
  }
}
.el-button--text {
  color: #000;
}
button.is-disabled {
  color: #cccccc;
}
.opple-button.primary.medium {
  width: 210px;
  height: 48px;
  box-sizing: border-box;
}
.hidden-date {
  opacity: 0;
}
::v-deep .el-calendar {
  .el-calendar-table {
    width: 100%;
    height: 100%;
    &:not(.is-range) {
      。 td.next {
        pointer-events: none;
      }
      td.prev {
        pointer-events: none;
      }
    }
  }
}
</style>
